import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Styled"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "styled"
    }}>{`Styled`}</h1>
    <p>{`As of Theme UI 0.6, `}<inlineCode parentName="p">{`Styled`}</inlineCode>{` components dict was renamed to `}<inlineCode parentName="p">{`Themed`}</inlineCode>{` to avoid
confusion with `}<inlineCode parentName="p">{`styled`}</inlineCode>{` components constructor function from `}<inlineCode parentName="p">{`@emotion/styled`}</inlineCode>{`.`}</p>
    <p><a parentName="p" {...{
        "href": "https://theme-ui.com/themed"
      }}>{`Go to the docs for Themed`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      